<template>
  <div class="layout-options-config">
    <header-config v-if="inDocument === 'header' || inDocument === 'relativeHeader'" :options="options" />
    <el-collapse v-if="inDocument === 'anchor'" v-model="activeNames" style="width: 100%">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="锚点按钮" name="1">
        <div class="verticallyCenter mr12">
          <span class="fs14 mr8">组件宽度</span>
          <single-input
            class="input-size"
            style="width: 60%;"
            :value.sync="anchorWidth"
            noInputSuffixs="px"
            placeholder="-"
            :min="1"
          />
        </div>
        <cx-slider
          class="mt12"
          v-if="isNewAnchor && !isRollerAnchor"
          :options="[
            { title: '点击', value: 'click' },
            { title: '悬停', value: 'hover' }
          ]"
          label="切换方式"
          :value.sync="anchorTrigger"
        ></cx-slider>
        <el-checkbox v-if="!isNewAnchor" v-model="isOpenToTop" label="开启“回到顶部”" class="mt12"></el-checkbox>
        <el-checkbox v-if="!isNewAnchor" v-model="isPackAnchor" label="允许收起锚点" class="mt12"></el-checkbox>
        <slider-and-input class="mt12" v-if="isNewAnchor" :value.sync="anchorScrollTop" title="定位偏移" :sliderMax="1000" suffix="px" />
        <el-checkbox v-if="isNewAnchor" v-model="firstPageShow" label="首屏显示锚点" class="mt12"></el-checkbox>
        <!-- isNewAnchor 用于判断是否显示新的设置项 -->
        <div><el-checkbox v-model="isNewAnchor" label="新锚点样式" class="mt12"></el-checkbox></div>
        <el-checkbox v-model="isRollerAnchor" label="锚点样式2" class="mt12"></el-checkbox>
        <div class="mt12" v-if="isRollerAnchor">
          <span class="fs14 mr8">线条颜色</span>
          <div class="content mt8">
            <cx-color-picker class="flex1" :isThemeColor.sync="lineColorIsThemeColor" :colorArr.sync="lineColor">
            </cx-color-picker>
          </div>
          <div class="fs14 mt12">线条偏移值</div>
          <slider-and-input :value.sync="marginLeft" title="" :sliderMax="200" suffix="px" />
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="锚点内容" name="2">
        <ul class="edit-box">
          <li
            class="tr verticallyCenter"
            v-for="(item, index) in usedAnchorData"
            :key="index"
            @click="editClick(item, index)"
          >
            <div class="td">
              <div class="btnIcon" v-if="item.iconType === 'icon'" v-html="item.svg"></div>
              <img :src="item.iconSrc || defaultImage" alt="" class="btnIcon" v-if="item.iconType === 'img'" />
            </div>
            <div class="td text">
              <span class="overflowHid2">{{ item.content }}</span>
            </div>
            <!-- <div class="td"><i class="icon-portal-edit-1 edit" @click="editClick(item, index)"></i></div> -->
            <div class="td" v-if="item.anchorShow && isNewAnchor">
              <!-- <el-tooltip slot="label" class="item" effect="dark" content="显示" placement="top-end" :open-delay="1000"> -->
                <i class="icon-portal-preview-open edit" @click.stop="editShow(item, index, false)"></i>
              <!-- </el-tooltip> -->
            </div>
            <div class="td" v-else-if="!item.anchorShow && isNewAnchor">
              <!-- <el-tooltip slot="label" class="item" effect="dark" content="隐藏" placement="top-end" :open-delay="1000"> -->
                <i class="icon-portal-preview-close edit" @click.stop="editShow(item, index, true)"></i>
              <!-- </el-tooltip> -->
            </div>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
    <div class="dialog-wrap" v-if="showDialog && inDocument === 'anchor'" @click.stop="closeDialog()">
      <div class="dialog" @click.stop>
        <div class="dialog-title verticallyBetween">
          <span>编辑锚点内容</span>
          <span class="close el-icon el-icon-close" @click="closeDialog()"></span>
        </div>
        <div class="dialog-content">
          <p class="lable">名称</p>
          <el-input v-model="editInfo.content" placeholder="请输入名称" class="mt4"></el-input>
          <template v-if="isNewAnchor">
            <p class="lable mt12">提示文字</p>
            <el-input v-model="editInfo.tips" placeholder="请输入名称" class="mt4"></el-input>
          </template>
          <template v-if="pageEnableFullScroll">
            <p class="lable mt12">整屏切换跳转方式:</p>
            <el-select v-model="editInfo.fullSwitchType" class="mt12" style="width: 100%">
              <el-option label="跳转上一屏" value="up"></el-option>
              <el-option label="跳转下一屏" value="down"></el-option>
              <el-option label="跳转指定屏" value="toAssignedPage"></el-option>
            </el-select>
            <p class="lable mt12" v-if="editInfo.fullSwitchType === 'toAssignedPage'">指定跳转屏:</p>
            <el-input
              :controls="false"
              class="mt12"
              type="number"
              v-if="editInfo.fullSwitchType === 'toAssignedPage'"
              v-model="editInfo.fullSwitchPage"
              placeholder="请输入需要跳转的通栏顺序"
            ></el-input>
          </template>
          <p class="lable mt12">默认状态图标</p>
          <img-icon-upload
            class="mt4"
            :imgSrc.sync="editInfo.iconSrc"
            :iconType.sync="editInfo.iconType"
            :iconColor.sync="editInfo.iconColor"
            :resInfo.sync="editInfo.resInfo"
          />
          <template v-if="isNewAnchor">
            <p class="lable mt12">选中状态图标</p>
            <img-icon-upload
              class="mt4"
              :imgSrc.sync="editInfo.activeIconSrc"
              :iconType.sync="editInfo.activeIconType"
              :iconColor.sync="editInfo.activeIconColor"
              :resInfo.sync="editInfo.activeResInfo"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isHasPlugins } from "utils"
import headerConfig from "./header-config"
import defaultImgSrc from "../../../assets/images/image_placeholder.png"
export default {
  name: "pageLayout-options-config",
  props: {
    options: Object
  },
  data() {
    return {
      contextPath: "",
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      this1: this,
      showDialog: false,
      elementList: [],
      btnInfoList: [],
      defaultImage: defaultImgSrc,
      editInfo: {},
      editInfoIndex: 0
    }
  },
  comments: {},
  components: { headerConfig },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    !this.isNewAnchor && this.findBtnInfo()
  },
  watch: {
    editInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.isNewAnchor) {
          this.newAnchorData.splice(this.editInfoIndex, 1, newVal)
        } else {
          this.$changeOptionsEV(newVal.content, "content", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.tips, "tips", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.iconSrc, "iconSrc", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.iconType, "iconType", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.activeIconType, "activeIconType", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.activeIconType, "activeIconType", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.activeIconSrc, "activeIconSrc", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.activeIconColor, "activeIconColor", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.activeResInfo, "activeResInfo", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
          this.$changeOptionsEV(newVal.anchorShow, "anchorShow", null, false, {
            container_id: this.ids.container_id,
            rect_id: newVal.rect_id
          })
        }
      }
    }
  },
  computed: {

    pageEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },    
    newAnchorData() {
      return this.layoutOptions.anchorData || []
    },
    usedAnchorData() {
      return this.isNewAnchor ? this.newAnchorData.map(item => {
        if (item.iconType === 'icon') {
          item.svg = this.getSvgContent(item.iconSrc)
        }
        if (item.activeIconType === 'icon') {
          item.activeSvg = this.getSvgContent(item.activeIconSrc)
        }
        return item
      }) : this.btnInfoList
    },
    ids() {
      return this.$store.state.states.activeID
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    layoutOptions() {
      return this.options.options
    },
    inDocument() {
      return this.layoutOptions.inDocument
    },
    anchorWidth: {
      get() {
        return this.layoutOptions.anchorWidth || 40
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorWidth", false)
      }
    },
    anchorTrigger: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorTrigger", "anchorTrigger", "click")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorTrigger", false)
      }
    },
    anchorHeight: {
      get() {
        return this.layoutOptions.anchorHeight || 300
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorHeight", false)
      }
    },
    isOpenToTop: {
      get() {
        return this.layoutOptions.isOpenToTop || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isOpenToTop", false)
        // backTop 返回顶部按钮插件名
        let buttonEle = this.findElement("backTop")
        if (buttonEle) {
          this.$changeOptionsEV(newVal, "isShow", null, false, {
            container_id: this.ids.container_id,
            rect_id: buttonEle.rect_id
          })
        }
      }
    },
    isPackAnchor: {
      get() {
        return this.layoutOptions.isPackAnchor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isPackAnchor", false)
        // packUp 收起按钮插件名
        let buttonEle = this.findElement("packUp")
        if (buttonEle) {
          this.$changeOptionsEV(newVal, "isShow", null, false, {
            container_id: this.ids.container_id,
            rect_id: buttonEle.rect_id
          })
        }
      }
    },
    isNewAnchor: {
      get() {
        return this.layoutOptions.isNewAnchor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isNewAnchor", false)
      }
    },
    // 锚点特殊样式 转盘
    isRollerAnchor: {
      get() {
        return this.layoutOptions.isRollerAnchor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isRollerAnchor", false)
      }
    },
    marginLeft: {
      get() {
        return this.layoutOptions.hasOwnProperty("marginLeft") ? this.layoutOptions.marginLeft : 38
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginLeft", false)
      }
    },
    lineColor: {
      get() {
        return this.layoutOptions.lineColor || "#b8bdcc"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineColor", false)
      }
    },
    lineColorIsThemeColor: {
      get() {
        return this.layoutOptions.lineColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineColorIsThemeColor", false)
      }
    },
    iconSrc: {
      get() {
        return this.layoutOptions.iconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.layoutOptions.iconType || "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconColor: {
      get() {
        return this.options.layoutOptions || ""
      },
      set(newVal) {
        // console.log(newVal);
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    firstPageShow: {
      get() {
        return this.layoutOptions.hasOwnProperty("firstPageShow") ? this.layoutOptions.firstPageShow : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "firstPageShow", false)
      }
    },
    anchorScrollTop: {
      get() {
        return this.layoutOptions.hasOwnProperty("anchorScrollTop") ? this.layoutOptions.anchorScrollTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorScrollTop", false)
      }
    }
  },
  methods: {
    findBtnInfo() {
      this.elementList = []
      this.btnInfoList = []
      let parentLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        { pageLayoutId: this.ids.pageLayoutId },
        "pageLayout"
      )
      let rectIds = parentLayout?.layout?.rows[0]?.rectIds
      if (rectIds) {
        rectIds.forEach(item => {
          this.elementList.push(
            this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
          )
        })
      }
      const list = this.elementList.filter(
        item => !isHasPlugins(item.options, "backTop") && !isHasPlugins(item.options, "packUp")
      )
      list.forEach(item => {
        const {
          content,
          tips,
          iconSrc,
          iconType,
          iconColor,
          resInfo,
          anchorShow = true,
          activeIconSrc = "",
          activeIconType = "img",
          activeIconColor = "#444",
          activeResInfo = {}
        } = item.options
        const svg = this.getSvgContent(iconSrc)
        const activeSvg = this.getSvgContent(activeIconSrc)
        this.btnInfoList.push({
          anchorShow: anchorShow,
          rect_id: item.rect_id,
          content: content,
          iconSrc: iconSrc,
          iconType: iconType,
          iconColor: iconColor,
          resInfo: resInfo,
          svg: svg,
          activeIconSrc,
          activeIconType,
          activeIconColor,
          activeResInfo,
          activeSvg,
          tips
        })
      })
      this.$changeOptionsEV(this.btnInfoList, "btnInfoList", false)
    },
    getSvgContent(encrypt) {
      if (!!encrypt) {
        let svgContent = this.$store.state.states.iconSvg
        if (svgContent && svgContent.hasOwnProperty(encrypt)) {
          return svgContent[encrypt]
        }
        if (!svgContent || !svgContent.hasOwnProperty(encrypt)) {
          this.$store.commit("states/updateSvg", {
            svgId: encrypt,
            value: ""
          })
        }
        this.instance.get(this.contextPath + `v2/svg/${encrypt}`).then(res => {
          if (res.status === 200) {
            return res.data
          }
        })
      } else {
        return ""
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    /* 查找通栏中的指定按钮 */
    findElement(pluginName) {
      for (var i = 0; i < this.elementList?.length; i++) {
        if (this.elementList[i] && isHasPlugins(this.elementList[i].options, pluginName)) {
          return this.elementList[i]
        }
      }
    },
    closeDialog() {
      this.showDialog = false
      !this.isNewAnchor && this.findBtnInfo()
    },
    editClick(item, index) {
      this.showDialog = true
      this.editInfo = JSON.parse(JSON.stringify(item))
      this.editInfoIndex = index
    },
    editShow(item, index, value) {
      this.editInfoIndex = index
      this.editInfo = { ...JSON.parse(JSON.stringify(item)), anchorShow: value }
      this.$nextTick(() => {
        !this.isNewAnchor && this.findBtnInfo()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

.edit-box {
  width: 100%;
  .tr {
    cursor: pointer;
    gap: 6px;
    align-items: center;
    width: 100%;
    height: 32px;
    border-radius: 4px;
    padding: 0 6px;
    border: 1px solid var(--borderColorNine);
    background: rgba(243, 243, 243, 1);
    margin-bottom: 8px;
    &:hover {
      background: rgba(233, 233, 233, 1);
    }
    .td {
      height: 100%;
      display: flex;
      align-items: center;
      text-align: left;
      font-size: 13px;
      line-height: 18px;
      &.text {
        flex: 1;
        color: rgba(0, 0, 0, 0.8);
        font-size: 13px;
      }

      .btnIcon {
        width: 20px;
        height: 20px;
        object-fit: cover;
      }

      .edit {
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }
  }
}

.dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 9999;
}

.dialog {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.8);

  .dialog-title {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
    padding-left: 12px;
    padding-right: 8px;
    font-weight: 600;

    .close {
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;

      &:hover {
        color: var(--subTextColor);
        background: var(--inputNuberHoverThemeBgColor);
      }
    }
  }

  .dialog-content {
    padding: 8px 12px 12px;

    .lable {
      font-size: 13px;
    }
  }
}

.verticallyBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mt4 {
  margin-top: 4px;
}

::v-deep svg {
  width: 100%;
  height: 100%;
}
</style>
